import React from 'react';
import { motion } from 'framer-motion';
export function MyStorySection() {
  return <section id="historia" className="py-24 bg-[#0f0f0f] relative border-y border-white/5" data-id="element-160">
      <div className="container mx-auto px-4" data-id="element-161">
        {/* Header Statement */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-20 max-w-4xl mx-auto" data-id="element-162">
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-['Bebas_Neue'] text-white leading-none mb-6" data-id="element-163">
            NO VENGO A VENDERTE UN CURSO.
            <br data-id="element-164" />
            <span className="text-[#C9A84C]" data-id="element-165">
              VENGO A CONTARTE LO QUE YO VIVÍ.
            </span>
          </h2>

          <div className="w-16 h-[2px] bg-[#C9A84C] mx-auto mb-8" data-id="element-166" />

          <p className="text-gray-400 text-base md:text-lg leading-relaxed font-light max-w-3xl mx-auto" data-id="element-167">
            Esto lo preparé para la persona que ya no aguanta más levantarse y
            sentir que{' '}
            <span className="text-gray-200 font-medium" data-id="element-168">nada cambia</span>. Que
            sabe lo que tiene que hacer pero no lo hace. Que está cansada de sí
            misma.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-169">
          {/* Left: Story Text */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-170">
            <div className="mb-6" data-id="element-171">
              <span className="text-[#C9A84C] text-xs font-bold tracking-[0.2em] uppercase" data-id="element-172">
                Mi historia
              </span>
            </div>

            <h3 className="text-4xl md:text-5xl font-['Bebas_Neue'] text-white mb-8 leading-none" data-id="element-173">
              YO TAMBIÉN ERA MI PROPIO{' '}
              <span className="text-[#C9A84C]" data-id="element-174">OBSTÁCULO.</span>
            </h3>

            {/* Raw confessions */}
            <div className="space-y-3 mb-8" data-id="element-175">
              {['Fumaba 5 porros por día.', 'No salía de la cama.', 'Gastaba todo en dopamina.', 'Empezaba todo y no terminaba nada.'].map((word, i) => <p key={i} className="text-xl text-gray-400 font-light border-l-2 border-gray-700 pl-4" data-id="element-176">
                  {word}
                </p>)}
            </div>

            <div className="w-full h-[1px] bg-gradient-to-r from-[#C9A84C]/50 via-[#C9A84C]/20 to-transparent mb-8" data-id="element-177" />

            {/* Core story — condensed */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="p-8 border-l-4 border-[#C9A84C] bg-white/[0.02] space-y-5 mb-8" data-id="element-178">
              <p className="text-gray-300 leading-relaxed" data-id="element-179">
                En <span className="text-[#C9A84C] font-semibold" data-id="element-180">2022</span> me
                quedé sin trabajo, perdí a la persona que estaba conmigo, no
                tenía vínculo con mi familia.{' '}
                <span className="text-white font-medium" data-id="element-181">
                  Estaba completamente solo.
                </span>
              </p>
              <p className="text-gray-300 leading-relaxed" data-id="element-182">
                Caí en las drogas para escapar del dolor. Un porro se convirtió
                en cinco por día. Llegué a esconderme porque no podía pagar el
                alquiler.{' '}
                <span className="text-[#C9A84C]" data-id="element-183">
                  Me quedé una semana en cama, arrastrándome por el piso para
                  bañarme.
                </span>
              </p>
              <p className="text-gray-300 leading-relaxed" data-id="element-184">
                Un día me di cuenta de que el dolor de quedarme igual era peor
                que el dolor de cambiar.{' '}
                <span className="text-white font-medium" data-id="element-185">
                  Empecé con una sola cosa: levantarme a la misma hora todos los
                  días.
                </span>{' '}
                Eso fue todo. Y de ahí no paré.
              </p>
            </motion.div>

            {/* Quote */}
            <div className="bg-[#C9A84C]/5 p-8 border border-[#C9A84C]/20 rounded-sm mb-6" data-id="element-186">
              <p className="text-xl text-white font-medium leading-relaxed" data-id="element-187">
                Hoy entreno carácter.
                <br data-id="element-188" />
                <span className="text-[#C9A84C]" data-id="element-189">
                  Y enseño lo que practico.
                </span>
              </p>
            </div>

            <p className="text-gray-400 leading-relaxed text-sm" data-id="element-190">
              El dinero es la consecuencia de lo que uno se vuelve.{' '}
              <span className="text-[#C9A84C] font-medium" data-id="element-191">
                Quizás acá encontrás esa versión.
              </span>
            </p>

            <p className="text-center text-gray-600 text-xs italic mt-8 tracking-wide" data-id="element-192">
              "Todo lo puedo en Cristo que me fortalece." — Filipenses 4:13
            </p>
          </motion.div>

          {/* Right: Photo Grid */}
          <div className="space-y-8" data-id="element-193">
            {/* ANTES */}
            <div data-id="element-194">
              <div className="flex items-center gap-3 mb-4" data-id="element-195">
                <span className="text-xs font-bold tracking-[0.2em] text-gray-500 uppercase" data-id="element-196">
                  Antes
                </span>
                <div className="flex-1 h-[1px] bg-gray-800" data-id="element-197" />
              </div>
              <div className="grid grid-cols-3 gap-3" data-id="element-198">
                {['https://i.ibb.co/zHWPPdLp/Whats-App-Image-2026-02-20-at-11-39-50-AM.jpg', 'https://i.ibb.co/S4Wq1tGK/Whats-App-Image-2026-02-20-at-11-39-51-AM-1.jpg', 'https://i.ibb.co/cXc3fzBg/Whats-App-Image-2026-02-20-at-11-39-51-AM.jpg'].map((src, i) => <motion.div key={i} initial={{
                opacity: 0,
                scale: 0.95
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: i * 0.1
              }} className="aspect-[3/4] bg-[#1a1a1a] border border-gray-700/50 relative overflow-hidden" data-id="element-199">
                    <img src={src} alt={`Antes ${i + 1}`} className="absolute inset-0 w-full h-full object-contain grayscale" data-id="element-200" />
                    <div className="absolute inset-0 bg-black/30" data-id="element-201" />
                    <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-gray-600" data-id="element-202" />
                    <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-gray-600" data-id="element-203" />
                  </motion.div>)}
              </div>
            </div>

            {/* AHORA */}
            <div data-id="element-204">
              <div className="flex items-center gap-3 mb-4" data-id="element-205">
                <span className="text-xs font-bold tracking-[0.2em] text-[#C9A84C] uppercase" data-id="element-206">
                  Ahora
                </span>
                <div className="flex-1 h-[1px] bg-[#C9A84C]/30" data-id="element-207" />
              </div>
              <div className="grid grid-cols-3 gap-3" data-id="element-208">
                {['https://i.ibb.co/0ythGWGc/Whats-App-Image-2026-02-20-at-12-04-19-PM-2.jpg', 'https://i.ibb.co/pFBdY3C/Whats-App-Image-2026-02-20-at-12-04-19-PM.jpg', 'https://i.ibb.co/s9MStbmv/Whats-App-Image-2026-02-20-at-12-04-19-PM-1.jpg'].map((src, i) => <motion.div key={i} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: i * 0.15
              }} className="aspect-[3/4] bg-[#1a1a1a] border border-[#C9A84C]/30 relative overflow-hidden" data-id="element-209">
                    <img src={src} alt={`Ahora ${i + 1}`} className="absolute inset-0 w-full h-full object-contain" data-id="element-210" />
                    <div className="absolute inset-0 bg-black/10" data-id="element-211" />
                    <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#C9A84C]" data-id="element-212" />
                    <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#C9A84C]" data-id="element-213" />
                  </motion.div>)}
              </div>

              {/* Texto debajo de las fotos de Ahora */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.7,
              delay: 0.3
            }} className="mt-6 space-y-4" data-id="element-214">
                <p className="text-gray-300 leading-relaxed text-sm" data-id="element-215">
                  Este soy yo luego de decidir desapegarme de viejos hábitos. De
                  empezar a quererme a mí mismo. De echar la culpa — y darme
                  cuenta de que la culpa era mía por estar donde estaba.{' '}
                  <span className="text-white font-medium" data-id="element-216">
                    Que solo yo tenía el camino en la cabeza para poner un plan
                    bajo disciplina y lograrlo.
                  </span>
                </p>
                <p className="text-gray-400 leading-relaxed text-sm" data-id="element-217">
                  Pasé por un lugar donde muchos pasan, pero pocos salen.
                </p>
                <div className="border-l-2 border-[#C9A84C] pl-4 py-1" data-id="element-218">
                  <p className="text-[#C9A84C] font-medium italic text-base leading-snug" data-id="element-219">
                    "Estás en el fondo del mar. Ahora solo queda empezar a nadar
                    para arriba."
                  </p>
                </div>
                <p className="text-gray-300 leading-relaxed text-sm" data-id="element-220">
                  Y hice exactamente eso —{' '}
                  <span className="text-white font-medium" data-id="element-221">empecé a nadar</span>{' '}
                  sin mirar el problema que tenía ni la droga de la que
                  dependía.
                </p>

                {/* Versículo */}
                <p className="text-center text-gray-600 text-xs italic mt-3 tracking-wide" data-id="element-222">
                  "Todo lo puedo en Cristo que me fortalece." — Filipenses 4:13
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}